<template>
  <div>
    <el-form
      style="width: 100%"
      :rules="addRules"
      ref="form"
      :inline="true"
      :model="form"
      label-width="80px"
      :center="true"
    >
      <el-form-item label="标准序号" prop="StIndex">
        <el-input
          style="width: 200px"
          v-model="form.StIndex"
          placeholder="标准序号"
          :disabled="!isEdit"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="标准分值" prop="Score">
        <el-input
          type="number"
          style="width: 105px"
          v-model="form.Score"
          placeholder="标准分值"
          :disabled="!isEdit"
        >
        </el-input>
      </el-form-item>
      <el-form-item label="评分细则" prop="ReviewMethod">
        <el-input
          style="width: 400px"
          type="textarea"
          v-model="form.ReviewMethod"
          placeholder="评分细则"
          :disabled="!isEdit"
        >
        </el-input>
      </el-form-item>
      <!-- <el-form-item label="责任部门选择">
        <el-transfer
          style="width: 100%"
          filterable
          :titles="['所有部门', '已选部门']"
          filter-placeholder="请输入责任部门拼音"
          v-model="form.PrimaryDepartments"
          :data="deptlist"
          :disabled="!isEdit"
        >
        </el-transfer>
      </el-form-item>
      <el-form-item label="协助部门选择">
        <el-transfer
          style="width: 100%"
          filterable
          :titles="['所有部门', '已选部门']"
          filter-placeholder="请输入协助部门拼音"
          v-model="form.AssistDepartments"
          :data="deptlist"
          :disabled="!isEdit"
        >
        </el-transfer>
      </el-form-item> -->
      <el-form-item label="责任部门" prop="PrimaryDepartments">
        <el-select
          style="width: 400px"
          v-model="singlePrimaryDep"
          filterable
          @change="updatePrimaryDepLs"
          placeholder="未找到所选责任部门，可能已被删除"
          :disabled="true"
        >
          <el-option
            v-for="dept in deptlist"
            :key="dept.key"
            :label="dept.label"
            :value="dept.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="协助部门">
        <el-select
          style="width: 400px"
          v-model="form.AssistDepartments"
          filterable
          multiple
          placeholder="请选择模块协助部门"
          :disabled="!isEdit"
        >
          <el-option
            v-for="dept in deptlist"
            :key="dept.key"
            :label="dept.label"
            :value="dept.key"
          >
          </el-option>
        </el-select>
      </el-form-item>
      <el-form-item
        style="display: flex; justify-content: center; align-items: center"
      >
        <el-button v-if="isEdit" type="primary" @click="submitForm('form')"
          >保存</el-button
        >
        <el-button @click="colseForm()">取消</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import {
  GetCheckModuleById,
  //考核细项
  AddCheckDetail,
  PutCheckDetail,
  GetCheckDetailStIndex,
} from "../../api/RatingManage/RatingManage";
import { GetDepartmentList } from "../../api/api";
export default {
  //外层传入值
  props: {
    value: {
      type: Object,
    },
  },
  //设置映射数据
  data() {
    return {
      //表单集合
      form: {
        StIndex: "",
        ReviewMethod: "",
        Score: 0,
        ModuleId: "",
        ItemId: "",
        PrimaryDepartments: [],
        AssistDepartments: [],
      },
      isEdit: false, //是否编辑模式
      addRules: {
        StIndex: [
          { required: true, message: "请输入标准序号", trigger: "blur" },
        ],
        Score: [{ required: true, message: "请输入标准分值", trigger: "blur" }],
        ReviewMethod: [
          { required: true, message: "请输入评分细则", trigger: "blur" },
          { max: 500, message: "评分细则不能超过500个字符", trigger: "blur" },
        ],
        PrimaryDepartments: [{ required: true, message: "所属模块未配置责任部门", trigger: "blur" }],
      },
      type: [
        {
          value: "1",
          label: "审核资料",
        },
        {
          value: "2",
          label: "其他",
        },
      ],
      deptlist: [], //所有科室列表
      singlePrimaryDep:'',
      module: {
        PrimaryDepLs: [],
        AssistDepLs: [],
      },
    };
  },
  //本页面需要用到的方法
  methods: {
    //获取科室列表并绑定到固定栏
    getDeptList() {
      GetDepartmentList().then((res) => {
        if (res.status == 200) {
          res.data.response.forEach((element) => {
            this.deptlist.push({ key: element.Id, label: element.Name });
          });
        }
      });
    },
    getStIndex() {
      GetCheckDetailStIndex({ pointId: this.form.ItemId }).then((res) => {
        this.form.StIndex = res.data.response;
      });
    },
    async getModuleInfo() {
      await GetCheckModuleById({ Id: this.form.ModuleId }).then((res) => {
        this.module = res.data.response;
      });
    },
    updatePrimaryDepLs(selectedValue) {
      this.form.PrimaryDepartments = selectedValue ? [selectedValue] : [];
    },
    //保存
    submitForm(formName) {
      this.$refs[formName].validate((valid) => {
        console.log(this.form);
        if (valid) {
          if (this.value.Id == 0) {
            //新增
            AddCheckDetail(this.form).then((res) => {
              console.log(res);
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
              this.$emit("submit-success", this.form.ItemId);
            });
          } //修改
          else {
            PutCheckDetail(this.form).then((res) => {
              console.log(res);
              if (res.data.success) {
                this.editLoading = false;
                this.$message({
                  message: res.data.msg,
                  type: "success",
                });
              } else {
                this.$message({
                  message: res.data.msg,
                  type: "error",
                });
              }
              this.$emit("submit-success", this.form.ItemId);
            });
          }
        } else {
          console.log("保存失败!!");
          return false;
        }
      });
    },
    colseForm() {
      this.$emit("colse-Detail");
    },
    resetForm(formName) {
      this.$refs[formName].resetFields();
    },
  },
  //初始化
  created() {
    //获取科室
    this.getDeptList();
    //判断是新增还是修改
    if (this.value.Id == 0) {
      this.form.ModuleId = this.value.ModuleId;
      this.form.ItemId = this.value.ItemId;
      this.getModuleInfo().then(() => {
        this.form.AssistDepartments = this.module.AssistDepLs;
        this.form.PrimaryDepartments = this.module.PrimaryDepLs;
        this.singlePrimaryDep = this.module.PrimaryDepLs.length > 0 ? this.module.PrimaryDepLs[0] : '';
      });

      //新增
      this.isEdit = true;
    } else {
      //修改或查看赋值
      this.form = this.value;
      this.singlePrimaryDep = this.form.PrimaryDepartments.length > 0 ? this.form.PrimaryDepartments[0] : '';
      this.isEdit = this.value.isEdit;
    }
  },
  mounted() {
    this.getStIndex();
  },
  watch:{
  },
};
</script>


